module.exports = __webpack_public_path__ + "static/AlbertusMTStd-Italic-b5284ab4ade2c940359b7f26de85ee18.woff";